import { ReactNode } from 'react'

interface CardV2Props {
  title?: string
  centered?: boolean
  children: ReactNode
  className?: string
}

const CardV2 = ({ title, centered, children, className = '' }: CardV2Props) => {
  return (
    <div
      className={`card p-6 ${centered ? 'flex flex-col items-center justify-center' : ''} ${className}`}
    >
      {title && (
        <h3 className="text-lg font-semibold text-neutral-800 mb-4">{title}</h3>
      )}
      {children}
    </div>
  )
}

export default CardV2
